<div class="Layout">
  <div class="Box" [class.w600]="isShopifyDomain">
    <h1 class="Title">
      <ng-content select=".auth-title"></ng-content>
    </h1>
    <ng-content select=".auth-content"></ng-content>
  </div>
</div>
